import React, { useContext, useEffect } from 'react';
import ABDetailHeader from './ABDetailHeader';
import AppletsSection from './AppletsSection';
import TrafficDistributionSection from './TrafficDistributionSection';
import MetricsSection from './MetricsSection';
import { getABTest, updateAbTest } from '../../services/ABServices';
import ScheduleSection from './ScheduleSection';
import { ABContext } from '../../contexts/ABContext';
import { TModel, TUpdateTest } from '../../types/ab';
import { toast } from 'react-toastify';
import TestDesignSection from './TestDesignSection';

type TABDetailPageProps = {
    testId?: string;
}

const ABDetailPage = ({ testId }: TABDetailPageProps) => {
    const abContext = useContext(ABContext);
    const { setIsLoading, setUpdateTest, models } = useContext(ABContext);

    useEffect(() => {
        if (testId) {
            setUpdateTest((prevUpdateTest: TUpdateTest) => ({
                ...prevUpdateTest,
                id: testId,
            }));
            getABDetail();
        }
    }, [testId]);


    const saveTest = async () => {
        try {
            if (!abContext?.setPayload || !abContext?.payload) {
                console.warn('AB Context or payload is not initialized');
                return;
            }
            let updatedPayload = abContext?.payload;
            if (!updatedPayload?.is_seasonal) {
                updatedPayload = {
                    ...updatedPayload,
                    is_seasonal: false,
                    season_end: null,
                    season_start: null,
                    metric: abContext.payload.metric || "Revenue",
                    test_duration: abContext.payload.test_duration || 1,
                };
                abContext.setPayload(updatedPayload);
            }
            if (!updatedPayload?.win_threshold) {
                updatedPayload = {
                    ...updatedPayload,
                    win_threshold: 0
                };
            }
            if (models) {
                const filteredModels = models.filter((model: TModel) => model.model_id !== null && model.model_id !== "");
                if (filteredModels?.length < 2) { toast.error("Please select at least 2 models"); return; }
                const totalPercentage = filteredModels?.reduce((acc: number, model: TModel) => acc + model.traffic_distribution, 0);
                if (totalPercentage !== 100) {
                    toast.error("Traffic distribution should be 100")
                    return;
                }
                if (updatedPayload.applets && updatedPayload.applets.length > 0) {
                    updatedPayload.applets[0] = {
                        ...updatedPayload.applets[0],
                        models: filteredModels,
                    };
                }
            }
            const response = await updateAbTest(updatedPayload);
            if (response?.done) {
                abContext?.setPayload(updatedPayload);
                toast.success(response?.message ?? "Updated A/B Test details!");
                return true;
            }
            else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.log("saveTest ~ error:", error);
        }
    };


    const getABDetail = async () => {
        try {
            setIsLoading(true);
            const response = await getABTest(testId ?? '');
            if (response?.done) {
                abContext?.setPayload(response?.data);
                abContext?.setPayloadNetworkCopy(response?.data);
            } else {
                toast.error(response?.message)
            }
        } catch (error) {
            console.log("error:", error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <ABDetailHeader testName={abContext?.payload?.name ?? ''} onSave={saveTest} />
            <AppletsSection />
            <TrafficDistributionSection />
            <MetricsSection />

            {testId && <TestDesignSection testId={testId} onSave={saveTest} />}
            {/* <PromotionPreference /> */}
            {testId && <ScheduleSection testId={testId} onSave={saveTest} />}
            <br />
        </>
    );
}

export default ABDetailPage;